import React, { useState, useEffect } from 'react';
import { VOTER_ORANGE, voterIcons } from '../component/voterCardIcons';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../context/AppIdContext';
import '../style/speakSearch.css';
import Header from '../component/header';
import WhatsappSlipButton from '../component/WhatsappSlipButton';
import PracharButton from '../component/PracharButton';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SurnameWise = () => {
    // --- Context & Router ---
    // Added userId to context extraction
    const { appId, language, userId } = useAppId();
    const navigate = useNavigate();
    const lang = language || 'en';

    // --- View State (Toggle between 'surnames' and 'voters') ---
    const [currentView, setCurrentView] = useState('surnames');

    // --- Surnames State ---
    const [surnames, setSurnames] = useState([]);
    const [selectedSurnames, setSelectedSurnames] = useState([]);
    const [surnameSearch, setSurnameSearch] = useState("");
    const [surnamePage, setSurnamePage] = useState(1);
    const surnamesPerPage = 50;

    // --- Voters State ---
    const [voters, setVoters] = useState([]);
    const [voterFilter, setVoterFilter] = useState("");
    const [voterPage, setVoterPage] = useState(1);
    const votersPerPage = 50;

    // --- Global Loading State ---
    const [loading, setLoading] = useState(true);

    // --- Translation Dictionary (Combined) ---
    const t = {
        en: {
            title: "Surname Wise Search",
            subtitle: "Select surnames to view voter distribution.",
            searchSurname: "Search Surnames...",
            showVoters: "Show Voters",
            clearAll: "Clear All",
            loadingSurnames: "Loading Surnames...",
            selectSurname: "Please select at least one surname.",
            noSurnamesFound: "No surnames found matching",
            surnamesSelected: "Surnames Selected",
            votersLabel: "Voters",
            changeSurname: "Change Surname",

            voterTitle: "Surname Search Results",
            subtitlePrefix: "Showing voters for:",
            searchVoter: "Filter displayed results by name...",
            loadingVoters: "Fetching Voters...",
            noVotersFound: "No voters found.",
            noMatchingNames: "No matching names found.",
            mobileNotAvailable: "Mobile number not available for this voter.",
            fetchFamilyFailed: "Could not fetch family details.",
            messageError: "Error generating message.",
            fatherHusband: "F/H :",
            address: "Address :",
            serialNumber: "Serial No. :",
            mobile: "Mobile :",
            idCard: "ID Card :",
            boothNo: "Booth No. :",
            houseNo: "House No. :",
            pollingLocation: "Polling Location :",
            n_a: "N/A",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            print: "Print",
            family: "Family",
            addToGroup: "Add to Group",// Added translation
            addToGroupConfirm: "Are you sure you want to ADD this member to your group?",
            addToGroupSuccess: "Added to group successfully!",
            addToGroupFailed: "Failed to add to group.",
            addToGroupError: "An error occurred while adding to the group."
        },
        hi: {
            title: "उपनाम वार खोज",
            subtitle: "मतदाता वितरण देखने के लिए उपनाम चुनें।",
            searchSurname: "उपनाम खोजें...",
            showVoters: "मतदाता दिखाएं",
            clearAll: "सभी हटाएं",
            loadingSurnames: "उपनाम लोड हो रहे हैं...",
            selectSurname: "कृपया कम से कम एक उपनाम चुनें।",
            noSurnamesFound: "कोई उपनाम नहीं मिला",
            surnamesSelected: "उपनाम चयनित",
            votersLabel: "मतदाता",
            changeSurname: "उपनाम बदलें",

            voterTitle: "उपनाम खोज परिणाम",
            subtitlePrefix: "के लिए मतदाता दिखा रहा है:",
            searchVoter: "प्रदर्शित परिणामों को नाम से फ़िल्टर करें...",
            loadingVoters: "मतदाता लाए जा रहे हैं...",
            noVotersFound: "कोई मतदाता नहीं मिला।",
            noMatchingNames: "कोई मिलान नाम नहीं मिला।",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            fetchFamilyFailed: "परिवार विवरण प्राप्त नहीं किया जा सका।",
            messageError: "संदेश बनाने में त्रुटि।",
            fatherHusband: "पिता/पति :",
            address: "पता :",
            serialNumber: "क्रमांक :",
            mobile: "मोबाइल :",
            idCard: "पहचान पत्र :",
            boothNo: "बूथ नं :",
            houseNo: "घर नं :",
            pollingLocation: "मतदान स्थान :",
            n_a: "N/A",
            call: "कॉल",
            text: "संदेश",
            slip: "स्लिप",
            prachar: "प्रचार",
            print: "प्रिंट",
            family: "परिवार",
            addToGroup: "ग्रूप में जोड़ें", // Added translation
            addToGroupConfirm: "क्या आप वाकई इस सदस्य को अपने ग्रूप में जोड़ना चाहते हैं?",
            addToGroupSuccess: "ग्रूप में सफलतापूर्वक जोड़ा गया!",
            addToGroupFailed: "ग्रूप में जोड़ने में विफल।",
            addToGroupError: "ग्रूप में जोड़ते समय एक त्रुटि हुई।"
        },
        gu: {
            title: "ઉપનામ વાઈઝ શોધ",
            subtitle: "મતદાર વિતરણ જોવા માટે ઉપનામો પસંદ કરો.",
            searchSurname: "ઉપનામો શોધો...",
            showVoters: "મતદારો બતાવો",
            clearAll: "બધા સાફ કરો",
            loadingSurnames: "ઉપનામો લોડ થઈ રહ્યા છે...",
            selectSurname: "કૃપા કરીને ઓછામાં ઓછું એક ઉપનામ પસંદ કરો.",
            noSurnamesFound: "કોઈ ઉપનામ મળ્યું નથી",
            surnamesSelected: "ઉપનામો પસંદ કરેલ",
            votersLabel: "મતદારો",
            changeSurname: "ઉપનામ બદલો",

            voterTitle: "ઉપનામ શોધ પરિણામો",
            subtitlePrefix: "માટે મતદારો બતાવી રહ્યા છે:",
            searchVoter: "પ્રદર્શિત પરિણામોને નામથી ફિલ્ટર કરો...",
            loadingVoters: "મતદારો લાવવામાં આવી રહ્યા છે...",
            noVotersFound: "કોઈ મતદાર મળ્યો નથી.",
            noMatchingNames: "કોઈ મેળ ખાતું નામ નથી.",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            fetchFamilyFailed: "કુટુંબ વિગતો મેળવી શકાઈ નહીં.",
            messageError: "સંદેશ બનાવવામાં ભૂલ.",
            fatherHusband: "પિતા/પતિ :",
            address: "સરનામું :",
            serialNumber: "ક્રમાંક :",
            mobile: "મોબાઇલ :",
            idCard: "ઓળખ કાર્ડ :",
            boothNo: "બૂથ નં :",
            houseNo: "ઘર નં :",
            pollingLocation: "મતદાન સ્થળ :",
            n_a: "N/A",
            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            print: "પ્રિંટ",
            family: "કુટુંબ",
            addToGroup: "જૂથમાં ઉમેરો", // Added translation
            addToGroupConfirm: "શું તમે ખરેખર આ સભ્યને તમારા જૂથમાં ઉમેરવા માંગો છો?",
            addToGroupSuccess: "જૂથમાં સફળતાપૂર્વક ઉમેરાયું!",
            addToGroupFailed: "જૂથમાં ઉમેરવામાં નિષ્ફળ.",
            addToGroupError: "જૂથમાં ઉમેરતી વખતે એક ભૂલ આવી."
        }
    };

    const txt = t[lang];
    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);



    // --- Edit Mobile API Call ---
const handleUpdateMobile = async () => {
    if (!newMobile || newMobile.length !== 10) {
        alert(txt.mobileErrorLength);
        return;
    }

    setIsSavingMobile(true);
    try {
        const payload = {
            app_id: appId?.toString(),
            voter_id: editingVoter.idcard_no,
            mobile_no: newMobile,
            modify_by: userId?.toString() || "1"
        };	

        const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

        if (response.data.success || response.data.Success === "1") {
            alert(txt.mobileUpdateSuccess);
            setVoters(prev => prev.map(v =>
                v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
            ));
            setIsEditMobileOpen(false);
        } else {
            alert(txt.mobileUpdateFailed);
        }
    } catch (error) {
        console.error("Error updating mobile:", error);
        alert(txt.mobileUpdateError);
    } finally {
        setIsSavingMobile(false);
    }
};



    // ==========================================
    // 1. SURNAME VIEW LOGIC
    // ==========================================
    useEffect(() => {
        if (appId) {
            fetchSurnames();
        }
    }, [appId]);

    const fetchSurnames = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_all_surname`, { app_id: appId });
            if (response.data.success) {
                setSurnames(response.data.data.result || []);
            }
        } catch (error) {
            console.error("Error fetching surnames:", error);
        } finally {
            setLoading(false);
        }
    };

    const toggleSelection = (surname) => {
        if (selectedSurnames.includes(surname)) {
            setSelectedSurnames(prev => prev.filter(s => s !== surname));
        } else {
            setSelectedSurnames(prev => [...prev, surname]);
        }
    };

    const handleClearSurnames = () => {
        setSelectedSurnames([]);
    };

    // Filter & Pagination for Surnames
    const filteredSurnames = surnames.filter(item =>
        item.surname && item.surname.toLowerCase().includes(surnameSearch.toLowerCase())
    );
    const indexOfLastSurname = surnamePage * surnamesPerPage;
    const indexOfFirstSurname = indexOfLastSurname - surnamesPerPage;
    const currentSurnamesList = filteredSurnames.slice(indexOfFirstSurname, indexOfLastSurname);
    const totalSurnamePages = Math.ceil(filteredSurnames.length / surnamesPerPage);

    const getSurnamePageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalSurnamePages <= maxVisibleButtons) {
            for (let i = 1; i <= totalSurnamePages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, surnamePage - 1);
            let endPage = Math.min(totalSurnamePages - 1, surnamePage + 1);
            if (surnamePage <= 3) endPage = 4;
            if (surnamePage >= totalSurnamePages - 2) startPage = totalSurnamePages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalSurnamePages - 1) pageNumbers.push('...');
            pageNumbers.push(totalSurnamePages);
        }
        return pageNumbers;
    };


    // ==========================================
    // 2. SWITCH TO VOTER VIEW LOGIC
    // ==========================================
    const handleShowVoters = async () => {
        if (selectedSurnames.length === 0) {
            alert(txt.selectSurname);
            return;
        }
        setCurrentView('voters');
        setLoading(true);
        setVoterFilter("");
        setVoterPage(1);

        let surnameString = selectedSurnames.join(',') + ',';

        try {
            const response = await axios.post(`${BASE_URL}/api/surname_wise_search`, {
                app_id: appId,
                surname_list: surnameString
            });

            if (response.data.success) {
                let resultData = response.data.data;
                if (typeof resultData === 'string') {
                    try { resultData = JSON.parse(resultData); }
                    catch (e) { console.warn("Parse error:", e); }
                }
                if (resultData && resultData.result) resultData = resultData.result;
                const votersArray = Array.isArray(resultData) ? resultData : (resultData ? [resultData] : []);
                setVoters(votersArray);
            } else {
                setVoters([]);
            }
        } catch (error) {
            console.error("Error fetching voters:", error);
            setVoters([]);
        } finally {
            setLoading(false);
        }
    };

    const handleBackToSurnames = () => {
        setCurrentView('surnames');
        // Selected surnames remain saved naturally!
    };


    // ==========================================
    // 3. VOTER VIEW LOGIC
    // ==========================================
    // --- Add to Group API Call ---
    const handleAddToGroup = async (voter) => {
        // Show confirmation alert using translated text
        const isConfirmed = window.confirm(txt.addToGroupConfirm);

        if (!isConfirmed) {
            return; // User cancelled the operation
        }

        try {
            const payload = {
                app_id: appId?.toString(),
                user_id: userId?.toString() || appId?.toString(),
                idcard: voter.idcard_no
            };

            const response = await axios.post(`${BASE_URL}/api/ins_my_group`, payload);

            if (response.data.success) {
                alert(txt.addToGroupSuccess);
            } else {
                alert(txt.addToGroupFailed);
            }
        } catch (error) {
            console.error("Error adding to group:", error);
            alert(txt.addToGroupError);
        }
    };

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert("Could not fetch family details.");
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert("Error generating message.");
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                // Open native SMS app with pre-filled body
                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };




    // Filter & Pagination for Voters
    const filteredVoters = voters.filter((voter) => {
        if (!voterFilter) return true;
        
        const searchTermLower = voterFilter.toLowerCase();
        
        const firstName = (voter.eng_f_name || "").toLowerCase();
        const lastName = (voter.eng_surname || "").toLowerCase();
        const fullName = `${firstName} ${lastName}`;
        const mobileNo = (voter.contact_no || "").toLowerCase();
        const idCardNo = (voter.idcard_no || "").toLowerCase();
        const ageSex = (voter.sex_age || "").toLowerCase();
        const age = (voter.age ? String(voter.age) : "").toLowerCase();
        const pollingLoc = (voter.eng_polling_location || "").toLowerCase();

        return (
            fullName.includes(searchTermLower) ||
            firstName.includes(searchTermLower) ||
            lastName.includes(searchTermLower) ||
            mobileNo.includes(searchTermLower) ||
            idCardNo.includes(searchTermLower) ||
            ageSex.includes(searchTermLower) ||
            age.includes(searchTermLower) ||
            pollingLoc.includes(searchTermLower)
        );
    });

    const indexOfLastVoter = voterPage * votersPerPage;
    const indexOfFirstVoter = indexOfLastVoter - votersPerPage;
    const currentVotersList = filteredVoters.slice(indexOfFirstVoter, indexOfLastVoter);
    const totalVoterPages = Math.ceil(filteredVoters.length / votersPerPage);

    const getVoterPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalVoterPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalVoterPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, voterPage - 1);
            let endPage = Math.min(totalVoterPages - 1, voterPage + 1);
            if (voterPage <= 3) endPage = 4;
            if (voterPage >= totalVoterPages - 2) startPage = totalVoterPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalVoterPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalVoterPages);
        }
        return pageNumbers;
    };


    // ==========================================
    // RENDER SURNAMES VIEW
    // ==========================================
    if (currentView === 'surnames') {
        return (
            <div className="app-container p-4">
                <Header title={txt.title} />

                <div className="filter-container mt-3">
                    <div className="search-wrapper-modern">
                        <svg className="search-icon-main" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            type="text"
                            className="search-input-modern"
                            placeholder={txt.searchSurname}
                            value={surnameSearch}
                            onChange={(e) => { setSurnameSearch(e.target.value); setSurnamePage(1); }}
                        />
                    </div>
                    <div className="action-group">
                        <button className="btn-show-voters" onClick={handleShowVoters} disabled={selectedSurnames.length === 0}>
                            {txt.showVoters} {selectedSurnames.length > 0 && `(${selectedSurnames.length})`}
                        </button>
                    </div>
                </div>

                {selectedSurnames.length > 0 && (
                    <div className="clear-selection-bar mt-1 ms-1 me-1">
                        <div className="selection-info">
                            <span className="count-badge">{selectedSurnames.length}</span>
                            <span className="selection-text">{txt.surnamesSelected}</span>
                        </div>
                        <button className="btn-clear-all" onClick={handleClearSurnames}>
                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" className="me-1">
                                <path d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            {txt.clearAll}
                        </button>
                    </div>
                )}

                <div className="dashboard-content">
                    {loading ? (
                        <div className="loader-wrapper"><div className="spinner"></div><p className="loader-text">{txt.loadingSurnames}</p></div>
                    ) : (
                        <>
                            <div className="row g-3">
                                {currentSurnamesList.length > 0 ? (
                                    currentSurnamesList.map((item, index) => {
                                        const isSelected = selectedSurnames.includes(item.surname);
                                        return (
                                            <div key={index} className="col-12 col-md-4 col-lg-3 col-xl-2">
                                                <div className={`surname-card-modern ${isSelected ? 'selected' : ''}`} onClick={() => toggleSelection(item.surname)}>
                                                    <div className="card-check">
                                                        {isSelected ? (
                                                            <svg width="20" height="20" fill="#2563eb" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
                                                        ) : (
                                                            <div className="unchecked-circle"></div>
                                                        )}
                                                    </div>
                                                    <div className="card-info">
                                                        <h3 className="surname-text">{item.surname}</h3>
                                                        <span className="voter-count">{item.total_voter} {txt.votersLabel}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="col-12 text-center p-5 text-muted">{txt.noSurnamesFound} "{surnameSearch}"</div>
                                )}
                            </div>

                            {/* Surname Pagination */}
                            {filteredSurnames.length > surnamesPerPage && (
                                <div className="pagination-wrapper">
                                    <div className="pagination-content">
                                        <button className="pagination-nav-btn" onClick={() => { setSurnamePage(surnamePage - 1); window.scrollTo(0, 0); }} disabled={surnamePage === 1}>
                                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                                        </button>
                                        <div className="page-numbers">
                                            {getSurnamePageNumbers().map((number, index) => (
                                                <React.Fragment key={index}>
                                                    {number === '...' ? <span className="page-dots">...</span> :
                                                        <button className={`page-num-btn ${surnamePage === number ? 'active' : ''}`} onClick={() => { setSurnamePage(number); window.scrollTo(0, 0); }}>{number}</button>
                                                    }
                                                </React.Fragment>
                                            ))}
                                        </div>
                                        <button className="pagination-nav-btn" onClick={() => { setSurnamePage(surnamePage + 1); window.scrollTo(0, 0); }} disabled={surnamePage === totalSurnamePages}>
                                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>

                <style jsx>{`
                    .app-container { background: #E5E7EB; min-height: 100vh; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; padding-bottom: 80px; }
                    
                    /* Search Bar */
                    .filter-container { display: flex; justify-content: space-between; align-items: center; gap: 16px; margin-bottom: 24px; }
                    .search-wrapper-modern { position: relative; flex: 1; max-width: 450px; }
                    .search-icon-main { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); color: #94a3b8; width: 20px; height: 20px; }
                    .search-input-modern { width: 100%; padding: 12px 16px 12px 42px; border: 1px solid #e2e8f0; border-radius: 10px; font-size: 14px; color: #1e293b; outline: none; transition: all 0.2s ease; box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
                    .search-input-modern:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); }
                    
                    /* Buttons */
                    .btn-show-voters { background-color: #2563eb; color: white; padding: 12px 24px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; transition: 0.2s; white-space: nowrap; box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2); }
                    .btn-show-voters:hover:not(:disabled) { background-color: #1d4ed8; transform: translateY(-1px); }
                    .btn-show-voters:disabled { background-color: #94a3b8; cursor: not-allowed; box-shadow: none; }
                    
                    /* Clear Selection Bar */
                    .clear-selection-bar { display: flex; justify-content: space-between; align-items: center; background-color: #1e293b; color: white; padding: 12px 20px; border-radius: 12px; margin-bottom: 24px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); }
                    .selection-info { display: flex; align-items: center; gap: 12px; }
                    .count-badge { background-color: #3b82f6; color: white; padding: 2px 10px; border-radius: 20px; font-weight: 800; font-size: 14px; }
                    .selection-text { font-size: 14px; font-weight: 500; }
                    .btn-clear-all { background: rgba(255, 255, 255, 0.1); border: 1px solid rgba(255, 255, 255, 0.2); color: #f87171; padding: 6px 14px; border-radius: 8px; cursor: pointer; font-size: 13px; font-weight: 600; transition: 0.2s; display: flex; align-items: center; }
                    .btn-clear-all:hover { background: #f87171; color: white; }

                    /* Cards */
                    .surname-card-modern { background: white; border: 1px solid #e2e8f0; border-radius: 12px; padding: 16px; display: flex; align-items: center; gap: 14px; cursor: pointer; transition: 0.2s ease; }
                    .surname-card-modern:hover { transform: translateY(-3px); border-color: #cbd5e1; box-shadow: 0 4px 6px rgba(0,0,0,0.05); }
                    .surname-card-modern.selected { background-color: #eff6ff; border-color: #3b82f6; border-width: 2px; }
                    .unchecked-circle { width: 20px; height: 20px; border: 2px solid #cbd5e1; border-radius: 50%; background: white; }
                    .surname-text { font-size: 15px; font-weight: 700; color: #0f172a; margin: 0; }
                    .voter-count { font-size: 12px; color: #64748b; font-weight: 600; }

                    /* Loader */
                    .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 40vh; width: 100%; }
                    .spinner { width: 40px; height: 40px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 12px; }
                    
                    /* Pagination */
                    .pagination-wrapper { display: flex; justify-content: center; padding: 20px 0; position: sticky; bottom: 20px; z-index: 50; }
                    .pagination-content { background: white; border: 1px solid #E2E8F0; border-radius: 50px; padding: 8px 16px; display: flex; align-items: center; gap: 8px; box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1); }
                    .pagination-nav-btn { width: 32px; height: 32px; border-radius: 50%; border: none; background: transparent; color: #2563eb; cursor: pointer; display: flex; align-items: center; justify-content: center; }
                    .pagination-nav-btn:disabled { color: #cbd5e1; cursor: not-allowed; }
                    .page-num-btn { min-width: 32px; height: 32px; border-radius: 50%; border: none; background: transparent; color: #64748b; font-weight: 600; font-size: 13px; cursor: pointer; transition: all 0.2s; }
                    .page-num-btn.active { background-color: #2563eb; color: white; }
                    .page-dots { color: #94A3B8; font-weight: bold; padding: 0 4px; }

                    @media (max-width: 640px) {
                        .filter-container { flex-direction: column; align-items: stretch; gap: 12px; }
                        .search-wrapper-modern { max-width: 100%; }
                        .btn-show-voters { width: 100%; }
                        .row.g-3 { margin-left: -6px; margin-right: -6px; }
                        [class*="col-"] { padding-left: 6px; padding-right: 6px; }
                    }
                `}</style>
            </div>
        );
    }

    // ==========================================
    // RENDER VOTERS VIEW
    // ==========================================
    const formattedSurnames = selectedSurnames.join(', ');

    return (
        <div className='app-container p-4'>
            {/* Header with Change Surname Button */}
            <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-3">
                <div style={{ flex: 1 }}>
                    <Header title={txt.voterTitle} subtitle="" />
                </div>

            </div>


            {/* Mobile Number Edit Modal */}
            {isEditMobileOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>Update Mobile Number</h4>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

                        <div style={{ marginBottom: '24px' }}>
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                placeholder="Enter 10-digit mobile number"
                                autoFocus
                            />
                            {/* 🔴 વેલિડેશન એરર મેસેજ */}
                            {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                                    {newMobile.length < 10
                                        ? "Mobile number must be 10 digits"
                                        : "Number must start with 6, 7, 8, or 9"}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                onClick={() => setIsEditMobileOpen(false)}
                                style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleUpdateMobile}
                                // 🔴 જો નંબર વેલિડ ન હોય તો બટન Disabled રહેશે
                                disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                                style={{
                                    padding: '10px 20px',
                                    background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                {isSavingMobile ? 'Saving...' : 'Save'}
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {/* Subtitle */}
            {formattedSurnames && (
                <div className="subtitle-container mb-4">
                    <p className="subtitle-text">
                        {txt.subtitlePrefix} <strong>{formattedSurnames}</strong>
                    </p>
                </div>
            )}

            {/* Voter Search Bar */}
            {voters.length > 0 && (
                <div className="filter-container-modern mb-4">
                    <div className="search-wrapper-modern">

                        <input
                            className="search-input-modern"
                            type="text"
                            placeholder={txt.searchVoter}
                            value={voterFilter}
                            onChange={(e) => { setVoterFilter(e.target.value); setVoterPage(1); }}
                        />
                    </div>
                    <button className="btn-change-surname text-white bg-primary ms-3 mt-1" onClick={handleBackToSurnames}>
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" className="me-2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z" />
                        </svg>
                        {txt.changeSurname}
                    </button>
                </div>

            )}

            {loading ? (
                <div className="loader-wrapper">
                    <div className="spinner"></div>
                    <p className="loader-text">{txt.loadingVoters}</p>
                </div>
            ) : (
                <>
                    <div className="row g-4 pb-5">
                        {currentVotersList.length > 0 ? (
                            currentVotersList.map((voter, index) => (
                                <div className="col-12 col-md-6 col-lg-4" key={index}>
                                    <div className="voter-card-clean h-100">
                                        <div className="voter-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div>
                                                <span className="serial-number">{index + 1 + indexOfFirstVoter}.</span>
                                                <span className="voter-name-bold ms-2">
                                                    {voter.eng_f_name} {voter.eng_surname}
                                                </span>
                                            </div>
                                            <button
                                                onClick={() => handleAddToGroup(voter)}
                                                style={{
                                                    backgroundColor: '#eff6ff',
                                                    color: '#2563eb',
                                                    border: '1px solid #bfdbfe',
                                                    borderRadius: '20px',
                                                    padding: '4px 10px',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseOver={(e) => { e.target.style.backgroundColor = '#dbeafe'; }}
                                                onMouseOut={(e) => { e.target.style.backgroundColor = '#eff6ff'; }}
                                            >
                                                + {txt.addToGroup}
                                            </button>
                                        </div>

                                        <div className="voter-body position-relative">
                                <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{voter.eng_m_name || txt.n_a}</span></div>
                                            <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                            <div className="info-row"><span className="label">{txt.serialNumber}</span><span className="value">{voter.slnoinpart}</span></div>
                                            <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                                <span className="label">{txt.mobile}</span>
                                                <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                                <svg
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setEditingVoter(voter);
                                                        setNewMobile(voter.contact_no || '');
                                                        setIsEditMobileOpen(true);
                                                    }}
                                                    style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                                    fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                                >
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                </svg>
                                            </div>
                                            <div className="info-row"><span className="label">{txt.idCard}</span><span className="value">{voter.idcard_no || txt.n_a}</span></div>
                                            <div className="info-row"><span className="label">{txt.boothNo}</span><span className="value">{voter.part_no || voter.booth_no || txt.n_a}</span></div>
                                            <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no || txt.n_a}</span></div>
                                            <div className="info-row"><span className="label">{txt.pollingLocation}</span><span className="value">{voter.eng_polling_location || "-"}</span></div>
                                        </div>

                                        <div className="voter-actions">
                                            <ActionButton icon={voterIcons.call} color={VOTER_ORANGE} label={txt.call}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                                        alert("Mobile number is not available for this voter.");
                                                    }
                                                    else {
                                                        window.open(`tel:${voter.contact_no}`, '_blank');
                                                    }
                                                }}

                                            />
                                            <ActionButton icon={voterIcons.text} color={VOTER_ORANGE} label={txt.text} onClick={() => handleSmsShare(voter)} />
                                            <WhatsappSlipButton voter={voter} />
                                            <PracharButton voter={voter} />
                                            <ActionButton
                                                icon={voterIcons.print} color={VOTER_ORANGE}
                                                label={txt.print}
                                                onClick={() => navigate('/printer', { state: { voter_id: voter.id } })}
                                            />
                                            <ActionButton icon={voterIcons.family} color={VOTER_ORANGE} label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="text-center text-muted p-5 w-100 modern-card mt-3">
                                <h4>{voters.length === 0 ? txt.noVotersFound : txt.noMatchingNames}</h4>
                            </div>
                        )}
                    </div>

                    {/* --- PAGINATION CONTROLS --- */}
                    {filteredVoters.length > votersPerPage && (
                        <div className="pagination-wrapper">
                            <div className="pagination-content">
                                <button className="pagination-nav-btn" onClick={() => { setVoterPage(voterPage - 1); window.scrollTo(0, 0); }} disabled={voterPage === 1}>
                                    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                                </button>
                                <div className="page-numbers">
                                    {getVoterPageNumbers().map((number, index) => (
                                        <React.Fragment key={index}>
                                            {number === '...' ? <span className="page-dots">...</span> :
                                                <button className={`page-num-btn ${voterPage === number ? 'active' : ''}`} onClick={() => { setVoterPage(number); window.scrollTo(0, 0); }}>{number}</button>}
                                        </React.Fragment>
                                    ))}
                                </div>
                                <button className="pagination-nav-btn" onClick={() => { setVoterPage(voterPage + 1); window.scrollTo(0, 0); }} disabled={voterPage === totalVoterPages}>
                                    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}

            <style jsx>{`
                .app-container { background: #E5E7EB; min-height: 100vh; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; padding-bottom: 80px; }
                
                .btn-change-surname { background-color: #f1f5f9; color: #1e293b; border: 1px solid #cbd5e1; padding: 10px 20px; border-radius: 10px; font-weight: 600; cursor: pointer; display: flex; align-items: center; transition: 0.2s; font-size: 14px; }
                .btn-change-surname:hover { background-color: #e2e8f0; border-color: #94a3b8; }

                .subtitle-container { margin-top: 8px; margin-bottom: 20px; position: relative; }
                .subtitle-text { font-size: 15px; color: #334155; margin: 0 0 10px 0; font-weight: 600; }
                .subtitle-text strong { color: #1e40af; font-weight: 700; }
                .subtitle-container::after { content: ""; display: block; width: 60px; height: 3px; background: linear-gradient(to right, #2563eb, #60a5fa); border-radius: 3px; margin-top: 4px; }

                .filter-container-modern { display: flex; justify-content: flex-start; align-items: center; }
                .search-wrapper-modern { position: relative; width: 100%; max-width: 450px; }
                .search-icon-main { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); color: #94a3b8; width: 20px; height: 20px; }
                .search-input-modern { width: 100%; padding: 12px 16px 12px 42px; border: 1px solid #e2e8f0; border-radius: 10px; font-size: 14px; color: #1e293b; background-color: #ffffff; outline: none; transition: all 0.2s ease; box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
                .search-input-modern:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); }

                .modern-card { background: #FFFFFF; border-radius: 16px; box-shadow: 0 4px 12px rgba(0,0,0,0.05); border: 1px solid #E2E8F0; }
                .btn-reset { background: none; border: none; cursor: pointer; padding: 0; display: flex; flex-direction: column; align-items: center; }
                
                .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 40vh; width: 100%; }
                .spinner { width: 40px; height: 40px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 12px; }

                .pagination-wrapper { display: flex; justify-content: center; padding: 30px 0 10px 0; position: sticky; bottom: 20px; z-index: 50; }
                .pagination-content { background: white; border: 1px solid #E2E8F0; border-radius: 50px; padding: 8px 16px; display: flex; align-items: center; gap: 8px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05); }
                .pagination-nav-btn { width: 32px; height: 32px; border-radius: 50%; border: none; background: transparent; color: #1e3a8a; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: 0.2s; }
                .pagination-nav-btn:hover:not(:disabled) { background-color: #eff6ff; }
                .pagination-nav-btn:disabled { color: #cbd5e1; cursor: not-allowed; }
                .page-num-btn { min-width: 32px; height: 32px; padding: 0 6px; border-radius: 50%; border: none; background: transparent; color: #64748b; font-weight: 600; font-size: 13px; cursor: pointer; transition: all 0.2s; }
                .page-num-btn:hover { color: #1e3a8a; background-color: #f8fafc; }
                .page-num-btn.active { background-color: #1e3a8a; color: white; box-shadow: 0 2px 4px rgba(30, 58, 138, 0.3); }
                .page-dots { color: #94A3B8; font-weight: bold; padding: 0 4px; }

                @media (max-width: 640px) {
                    .filter-container-modern { flex-direction: column; align-items: stretch; gap: 12px; }
                    .search-wrapper-modern { max-width: 100%; }
                    .btn-change-surname { width: 100%; justify-content: center; }
                }
            `}</style>
        </div>
    );
};

// Updated ActionButton
const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default SurnameWise;